import { Facet } from '../models/Facet';

/**
 * A facet for a command that does NOT mutate the item it is acting on.
 * @beta
 */
export const isReadonlyFacet: Facet<boolean> = new Facet('readonly');

/**
 * A facet for a command that shares the item it is acting on.
 */
export const isShareFacet: Facet<boolean> = new Facet('share');